// extracted by mini-css-extract-plugin
export default {"cartDropdownContainer":"cartDropdown_cartDropdownContainer__cFWqq","emptyMessage":"cartDropdown_emptyMessage__QSZRJ","cartItems":"cartDropdown_cartItems__kurGZ"};